/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export default {
	'.MuiTypography-root': {
		textShadow: '0 0 0.3em white',
		color: 'black',
	},
} as SxProps;
